import { InputField } from 'lib/iterable-hook-form';
import { FormField, FormFieldProps } from 'ui/formField';

type Props = Omit<FormFieldProps, 'children'> & { name: string };

export const BasicInputField = ({ errorText, helpText, labelText, name, ...props }: Props) => {
  return (
    <FormField
      data-test={`basic-input-field-${name}`}
      errorText={errorText}
      hasError={!!errorText}
      helpText={!errorText && helpText}
      labelText={labelText}
      {...props}
    >
      <InputField name={name} />
    </FormField>
  );
};
